module.exports = __webpack_public_path__ + "7ce106ceb8c1a611b188c7016ed11bf0.png";